import { html } from 'lit';

export const iconProductImage = html`
  <svg
    width="44"
    height="38"
    viewBox="0 0 44 38"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path
      d="M38.2856 0C41.3392 0 43.7142 2.45982 43.7142 5.42857V32.5714C43.7142 35.625 41.2544 38 38.2856 38H5.71422C2.74547 38 0.285645 35.625 0.285645 32.5714V5.42857C0.285645 2.45982 2.74547 0 5.71422 0H38.2856ZM9.78564 5.42857C7.58029 5.42857 5.71422 7.29464 5.71422 9.5C5.71422 11.7902 7.41064 13.5714 9.78564 13.5714C12.0758 13.5714 13.8571 11.7902 13.8571 9.5C13.8571 7.29464 11.991 5.42857 9.78564 5.42857ZM38.2008 31.8929C38.3705 31.4688 38.3705 30.875 38.116 30.5357L27.2589 14.25C27.0044 13.8259 26.5803 13.5714 26.1562 13.5714C25.6473 13.5714 25.2231 13.8259 24.9687 14.25L17.0803 26.125L14.2812 22.308C14.0267 21.9688 13.6874 21.7143 13.2633 21.7143C12.7544 21.7143 12.4151 21.9688 12.1606 22.308L6.22314 30.4509C5.88386 30.875 5.88386 31.3839 6.0535 31.8929C6.30797 32.317 6.73207 32.5714 7.32582 32.5714H37.0133C37.4374 32.5714 37.9464 32.317 38.2008 31.8929Z"
      fill="currentColor"
    />
  </svg>
`;
